import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Hashtag } from '../models/hashtag';
import { HashtagPerWidget } from '../models/hashtagPerWidget';
import { HashtagService } from '../services/hashtag.service';
import { DestroyBase } from '../../../../components/common/ng-destroy-base';

/**
 * Hashtags per widget overview component
 */
@Component({
  selector: 'hashtags-per-widget',
  templateUrl: './hashtags-per-widget.component.html',
  styleUrls: ['./hashtags-per-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class HashtagsPerWidgetComponent extends DestroyBase implements OnInit, OnDestroy {

  /**
   * Widget Id
   */
  @Input() widgetId: number;

  /**
   * Emits when new hashtag is selected
   */
  @Output() hashTagSelected: EventEmitter<Hashtag> = new EventEmitter<Hashtag>();

  /**
   * List of all hashtags for widget
   */
  private allHashTags: Hashtag[] = [];

  /**
   * Fitered hashtags
   */
  public filteredHashTags: Hashtag[] = [];

  /**Search term for hashtags */
  public searchTerm: string;

  /**
   * Constructor
   * @param hashtagService HashtagService
   * @param ref ChangeDetectorRef
   */
  constructor(private hashtagService: HashtagService, private ref: ChangeDetectorRef) {
    super();
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.subscriptions.add(this.hashtagService.loadedHashTags$.subscribe((data) => {
      if (data) {
        this.allHashTags = data;
        this.filteredHashTags =  this.allHashTags;
        this.ref.markForCheck();
      }
    }));

    this.subscriptions.add(this.hashtagService.searchKey$.subscribe((searchTerm: string) => {
      if (searchTerm) {
        this.searchTerm = searchTerm;
        this.filteredHashTags = this.allHashTags.filter((tag) => { return tag.key.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0; });
        this.ref.markForCheck();
      }
      else {
        this.filteredHashTags = this.allHashTags;
        this.ref.markForCheck();
      }
    }));

    // refresh hashtags
    this.hashtagService.getAllHashtags();
  }

  /**
   * Sets and emits latest selected hashtag
   */
  onHashTagSelect(hashTag: Hashtag) {
    const hashtagPerWidget = new HashtagPerWidget();
    hashtagPerWidget.hashtag = hashTag;
    hashtagPerWidget.widgetId = this.widgetId;
    this.hashtagService.applyHashtagToWidget(hashtagPerWidget);
    this.ref.markForCheck();
  }

}
